const formattedNumber = (value, style = 'decimal', minimumFractionDigits = 0) => {
  if(!value || isNaN(value) || value === Infinity) {
    value = 0;
  }

  return new Intl.NumberFormat('pt-BR', { style, currency: 'BRL', minimumFractionDigits }).format(value);
}

export default formattedNumber;
